export class NewImport {
	constructor(
		public import_id?: number,
		public ftp?: any,
		public type?: any
	){}
}